import { Box, Typography } from "@mui/material";
import styled, { css } from "styled-components";

export const StyledSkewedBox = styled(Box)<{
  $backgroundColor: string;
  $skewAngle: number;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  height: 100%;

  background-color: ${(props) => props.$backgroundColor};
  transform: skewX(${(props) => props.$skewAngle}deg);
`;

export const StyledSkewedBoxWrapper = styled(Box)<{
  $skewAngle: number;
  $width?: string;
  $height?: string;
}>`
  display: inline-block;
  width: ${({ $width }) => $width ?? "auto"};
  height: ${({ $height }) => $height ?? "auto"};

  & > ${StyledSkewedBox} {
    ${({ $width, $skewAngle, $height }) => css`
      min-width: calc(
        ${$width} - ${$height ?? "86px"} * tan(${-$skewAngle}deg) * 1.1
      );
      margin-left: calc((${$height ?? "86px"} * tan(${-$skewAngle}deg)) / 2);
    `}
  }
`;

export const StyledContentContainer = styled(Box)<{ $skewAngle: number }>`
  display: flex;
  align-items: baseline;
  font-size: 48px;

  transform: skewX(${(props) => -props.$skewAngle}deg);
`;

export const StyledPrefixText = styled(Typography)<{ $textColor: string }>`
  && {
    color: ${(props) => props.$textColor};
    font-family: Roboto;
    font-weight: 700;
    font-size: 40px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;

    padding-right: 10px;
    text-transform: uppercase;

    @media (max-width: 1024px) {
      font-size: 32px;
    }
  }
`;

export const StyledMainText = styled(Typography)<{ $textColor: string }>`
  && {
    color: ${(props) => props.$textColor};
    font-family: Roboto;
    font-weight: 700;
    font-size: 96px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;

    @media (max-width: 1024px) {
      font-size: 64px;
    }
  }
`;
